export default {
    riskcontrol: {},
    batchStatusOptions: [ { id: -2, label: '已删除', color:'#FF0000' }, { id: -1, label: '已终止', color:'#FF00FF' }, { id: 1, label: '进行中', color:'#008000' }, { id: 2, label: '未开始', color:'#333333' }, { id: 3, label: '待验收', color:'#FFA500' }, { id: 4, label: '已完结', color:'#FF4500' } ],
    batchFunderStatusOptions: [ { id: 1, label: '进行中' }, { id: 2, label: '未开始' }, { id: 4, label: '已完结' } ]
};
